import { createAction } from 'typesafe-actions';

import { ErrorResult, LanguageDto, ResourcesDto } from 'common/api/autogenerated/trading-gateway';

import resourcesActionTypes from './actionTypes';

type EnhancedResourceDto = ResourcesDto & { culture: string };

export const actionGetResources = createAction(resourcesActionTypes.LOADING_GET_RESOURCES, (data: string) => data)<string>();
export const actionSuccessGetResources = createAction(resourcesActionTypes.SUCCESS_GET_RESOURCES, (data: EnhancedResourceDto) => data)<EnhancedResourceDto>();
export const actionErrorGetResources = createAction(resourcesActionTypes.ERROR_GET_RESOURCES, (error: ErrorResult) => error)<ErrorResult>();

export const actionGetLanguages = createAction(resourcesActionTypes.LOADING_GET_LANGUAGES)<void>();
export const actionSuccessGetLanguages = createAction(resourcesActionTypes.SUCCESS_GET_LANGUAGES, (data: LanguageDto[]) => data)<LanguageDto[]>();
export const actionErrorGetLanguages = createAction(resourcesActionTypes.ERROR_GET_LANGUAGES, (error: ErrorResult) => error)<ErrorResult>();
